var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"app-button app-button--magenta ripple",class:_vm.inverted && 'inverted',attrs:{"data-jest":"app-button"}},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v("Enviar")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }